import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
});

export const buttonContainerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
  button: {
    fontWeight: 'normal',
    width: '100%',
  },
});
